<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle d-block">Indicação</span>
        <h3 class="page-title d-inline">Visualizar</h3>
      </d-col>
    </d-row>

    <!-- Content -->
    <d-row>
      <d-col lg="12">
        <lead-page :lead="lead" ref="leadForm"/>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import LeadPage from '_modules/lead/components/LeadPage.vue';
import { MODEL, _LOAD_MODEL_ } from '../components/LeadModel';

export default {
  name: 'lead-edit',
  components: {
    LeadPage,
  },
  computed: {
    lead() {
      const { lead } = this.$store.state.lead;
      if (lead) {
        Events.$emit(_LOAD_MODEL_, lead);
        return lead;
      }
      return MODEL;
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getLead',
    ]),
    getLeadModel() {
      this.setToggle({ type: 'progress', bool: true });
      this.getLead(parseInt(this.$route.params.leadId, Number))
        .then(() => {
          this.setToggle({ type: 'progress', bool: false });
        });
    },
    save() {
      this.$refs.leadForm.save();
    },
  },
  mounted() {
    if (this.$route.params.leadId) {
      this.getLeadModel();
    }
  },
};
</script>

